import {Route} from '@angular/router';
import {MeterDataComponent} from './meter-data/meter-data.component';
import {MeterListComponent} from 'src/app/meter/meter-list/meter-list.component';
import {MeasuringPointsTableComponent} from 'src/app/meter/meter-and-sensors/measuring-points-table/measuring-points-table.component';
import {meterResolver} from '@shared/route-utils';
import {ReactOnlineIframeComponent} from 'src/app/building/react-online-iframe/react-online-iframe.component';
import {MeterListMapComponent} from './meter-list-map/meter-list-map.component';
import {BuildingServices} from '@brunata-angular/util';

export const meterRoutes: Route[] = [
    {path: '', redirectTo: 'stock', pathMatch: 'full'},
    {
        path: 'stock',
        component: ReactOnlineIframeComponent,
        data: {
            key: 'titles_meterStock',
            module: 'systems',
            reactRoute: 'buildings/{buildingno}/detail/meters',
        },
        children: [
            {
                path: 'showall',
                component: ReactOnlineIframeComponent,
                data: {
                    key: 'titles_allMeters',
                    module: 'systems',
                    reactRoute: 'buildings/{buildingno}/detail/meters/showall',
                },
            },
        ],
    },
    {
        path: 'meters-and-sensors',
        component: MeterListComponent,
        data: {key: 'utilities_meter_and_sensor_overview', module: 'ngonline'},
        children: [
            {
                path: ':meterid',
                component: MeterDataComponent,
                resolve: {meterNo: meterResolver},
            },
        ],
    },
    {
        path: 'measuring-points',
        component: MeasuringPointsTableComponent,
        data: {key: 'utilities_measuring-points', module: 'ngonline'},
    },
    {
        path: 'map',
        component: MeterListMapComponent,
        data: {
            key: 'common_map_of_devices',
            module: 'ngonline',
            requireBuildingService: BuildingServices.MAP_OF_DEVICES,
        },
    },
];
